export default [
  {value: 'clay',       label: 'Clay',           soilCoef: 11, coneCoef: 0.069, b_1: 26,  b_2: 1376},
  {value: 'silty-clay', label: 'Silty Clay',     soilCoef: 11, coneCoef: 0.046, b_1: 28,  b_2: 1018},
  {value: 'silt',       label: 'Silt',           soilCoef: 11, coneCoef: 0.034, b_1: 48,  b_2: 384},
  {value: 'silty-sand', label: 'Silty Sand',     soilCoef: 12, coneCoef: 0.017, b_1: 36,  b_2: 465},
  {value: 'sand',       label: 'Sand',           soilCoef: 12, coneCoef: 0.011, b_1: 24,  b_2: 1334},
  {value: 'bedrock',    label: 'Bedrock',        soilCoef: 13, coneCoef: 0.005, b_1: 195, b_2: 16124},
  {value: 'sensitive',  label: 'Fill/Sensitive', soilCoef: 8,  coneCoef: 0.050, b_1: 28,  b_2: 1018}
]
